module.exports = __webpack_public_path__ + "img/jrwm—icon.ef870dbf.png";